import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
import { beforeItems, afterItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white px-5 py-14 sm:py-20" data-id="element-60" data-mp="26ll08frx8f20">
      <div className="mx-auto w-full max-w-xl lg:max-w-5xl" data-id="element-61" data-mp="26k03qkm1qm1i">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink-900 sm:text-[34px]" data-id="element-62" data-mp="22m2czdcmnrw0">
          From feeling uncertain in a complex case to having a clear plan from the very first
          consultation
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-ink-900/60 sm:text-base" data-id="element-63" data-mp="2qabx8au707l1">
          Stop searching for answers across scattered articles, guidelines, and protocols. The Male
          Fertility Route organizes the entire clinical process into a logical sequence so every
          decision has a clear foundation.
        </p>

        <div className="mt-10 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-64" data-mp="19ushtbhimax2">
          <div className="rounded-2xl border border-red-200 bg-red-50/60 p-5 sm:p-6" data-id="element-65" data-mp="176fdmc264hzi">
            <p className="mb-4 text-[11px] font-extrabold uppercase tracking-[0.2em] text-red-700" data-id="element-66" data-mp="1c4yy08145lpr">
              Before
            </p>
            <ul className="space-y-4" data-id="element-67" data-mp="y461jhr94gk0">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-68" data-mp="132fz1z0g7t8s">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-600/10" data-id="element-69" data-mp="oeuv62vr1pzt">
                    <XIcon className="h-3.5 w-3.5 text-red-700" aria-hidden="true" data-id="element-70" data-mp="t5ut9bglue3w" />
                  </span>
                  <span className="text-[14px] leading-relaxed text-ink-900/75 sm:text-[15px]" data-id="element-71" data-mp="ff7vpmmkyu9e">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-teal-500/30 bg-teal-50/70 p-5 sm:p-6" data-id="element-72" data-mp="5hboh5wrkjgk">
            <p className="mb-4 text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal-700" data-id="element-73" data-mp="ads9vsckwjpy">
              With the Male Fertility Route
            </p>
            <ul className="space-y-4" data-id="element-74" data-mp="27dstgt12kxsb">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-75" data-mp="27bpxlsd8kafo">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-600/15" data-id="element-76" data-mp="23cqu8c75klqc">
                    <CheckIcon className="h-3.5 w-3.5 text-teal-700" aria-hidden="true" data-id="element-77" data-mp="1yaroivnxxcq8" />
                  </span>
                  <span className="text-[14px] leading-relaxed text-ink-900/80 sm:text-[15px]" data-id="element-78" data-mp="2v0sl3gujwxi3">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <TransformCTA tone="light" headline="Turn uncertainty into a clear clinical plan starting today." data-id="element-79" data-mp="2h3vn8vg0mfrp" />
      </div>
    </section>;
}